import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getMeterTariffTypes = async () => {
  const data = await request.get(
    '/RentPlace/meter/tariff/type',
    {},
    'При загрузке видов тарифа произошла ошибка',
    []
  );
  return data;
};

const useMeterTariffTypes = () =>
  useQuery(queries.meterTariffTypes, () => getMeterTariffTypes(), {
    placeholderData: [],
  });

export default useMeterTariffTypes;
